exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.display-time {\n  display: block;\n  width: 100% !important;\n  height: calc(1.5em + 0.75rem + 2px) !important;\n  padding: 0.375rem 0.75rem !important;\n  font-size: 1rem !important;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da !important;\n  border-radius: 0.125rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n", ""]);

// exports
